module.exports = __webpack_public_path__ + "static/img/10.055ecc7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/zh/10.png
// module id = EbhG
// module chunks = 0